<template>
  <div class="signup-partner">
    <big><strong>Continuar via SKY TV</strong></big>
    <p>Insira os dados da sua assinatura SKY</p>
     <form class="input-container" @submit.prevent="submit" novalidate autocomplete="off">
      <pk-input v-model="cpf" mask="###.###.###-##" :placeholder="$t('auth.signUp.placeholder.cpf')" type="text" :error="$v.cpf.$error" />
      <pk-input v-model="email" :placeholder="$t('auth.signUp.placeholder.email')" type="email" :error="$v.email.$error" />

      <pk-input v-model="code" :placeholder="$t('auth.signUp.placeholder.code')" type="text" :error="$v.code.$error" />
      <pk-input v-model="password" :placeholder="$t('auth.signUp.placeholder.password')" type="password" :error="$v.password.$error" />
      <error-text :active="!!errorCode || !!$v.$error">
        <span v-if="errorCode === 409">
          <span v-html="$t('auth.signUp.error.emailAlreadyExists.message')" />
          <a @click.prevent="$emit('changeAuthType', null)">{{ $t('auth.signUp.error.emailAlreadyExists.CTA') }}</a>
        </span>
        <span v-else-if="errorCode === 400" v-t.preserve="'auth.signUp.error.invalidRequest'" />
        <span v-else-if="!!errorCode" v-t.preserve="'auth.signUp.error.generic'" />
        <span v-else-if="$v.email.$error" v-t.preserve="emailError" />
        <span v-else-if="$v.password.$error" v-t.preserve="'auth.signUp.error.password'" />
      </error-text>
      <div class="terms">
         <consent-box v-model="consentPolicy" :shake="shakeBoxPrivacy" id="checkout-cadastro-cta-politica-de-privacidade">
          {{ $t('policies.privacy') }} <a id="checkout-cadastro-opt-in-politica-de-privacy" href="https://policies.playkids.com/pt/privacy/may-2020" target="_blank">{{ $t('policies.privacyTitle') }}</a>
        </consent-box>

        <consent-box v-model="consentTerms" :shake="shakeBoxTerms" id="checkout-cadastro-cta-termos-de-uso">
          {{ $t('policies.tos') }} <a id="checkout-cadastro-opt-in-termos-de-serviço" href="https://policies.playkids.com/pt/tos/may-2020" target="_blank">{{ $t('policies.tosTitle') }}</a>
        </consent-box>
      </div>

      <footer>
        <btn flat color="white" :loading="loading" @click="$emit('cancel')">{{ $t('tags.cancel') }}</btn>
        <btn flat :loading="loading" submit>{{ $t('auth.signUp.signUp') }}</btn>
      </footer>
    </form>
  </div>
</template>

<script>
import { cpf, ifoodEmail, strongPassword } from '@/js/validationUtils'
import { required, email, numeric } from 'vuelidate/lib/validators'
import { AuthenticationPlatform } from '@/api/peanutbutter'
import { mapActions, mapState } from 'vuex'
import authenticationService from '@/js/AuthenticationService'
import formSubmit from '@/js/mixins/formSubmit'
import skylerAPI from '@/api/skyler'

export default {
  name: 'SignUpPartnerForm',
  mixins: [formSubmit('signup')],
  data: () => ({
    cpf: '',
    code: '',
    email: '',
    password: '',
    consentVersion: '1.0.0',
    consentPolicy: false,
    consentTerms: false,
    shakeBoxPrivacy: false,
    shakeBoxTerms: false
  }),

  validations() {
    const validations = {
      email: { required, email },
      password: { required, strongPassword },
      cpf: { required, cpf },
      code: { required, numeric }
    }

    if (this.isIfoodOffer) {
      validations.email = { required, ifoodEmail }
    }

    return validations
  },

  watch: {
    '$v.$invalid' (next) {
      this.$emit('email-form', next)
    }
  },

  computed: mapState({ accountId: state => state.user.accountId }),
  methods: {
    ...mapActions({ verifyProfile: 'user/verifyProfile' }),
    verifyPolicyConsent() {
      this.shakeBoxPrivacy = false
      this.shakeBoxTerms = false

      if (!this.consentPolicy) {
        this.$nextTick(() => {
          this.shakeBoxPrivacy = true
        })
      }

      if (!this.consentTerms) {
        this.$nextTick(() => {
          this.shakeBoxTerms = true
        })
      }

      if (!this.consentPolicy || !this.consentTerms) {
        return false
      }

      return true
    },

    async signup() {
      if (!this.verifyPolicyConsent()) {
        return
      }

      const data = {
        credentials: {
          email: this.email,
          password: this.password
        },
        extraData: {},
        authenticationPlatform: AuthenticationPlatform.EMAIL,
        privacyPreferences: {
          privacyPolicy: {
            consent: this.consentPolicy,
            version: this.consentVersion
          },
          termsOfUse: {
            consent: this.consentTerms,
            version: this.consentVersion
          }
        }
      }

      try {
        await authenticationService.signUp(data)
        await skylerAPI.createSubscription(this.accountId, this.cpf, this.code)
        await this.verifyProfile()
        this.$emit('authenticated')
      } catch (err) {
        if (err.code) {
          throw err
        }

        this.errorCode = 400
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.signup-partner {
  .input-container {
    display: flex;
    flex-direction: row;
    .pk-input {
      width: 50%;
      padding: 1rem 1rem 0;
      @media ($screen-xs) {
        width: 100%;
      }
    }
    & > .consent-box {
      margin-bottom: 12px;
    }

    & > span {
      text-align: center;
      margin-bottom: 8px;
      font-weight: normal;

      &:last-child {
        margin-top: 8px;
      }
    }

    .signup-types {
      display: flex;
      flex-direction: column;
    }
  }
  footer {
    background: #F7F7F7;
    position: absolute;
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
    bottom: 0;
    left: 0;
    padding: 1em 3em
  }
  .terms {
    margin: 2em 0 6em;
    @media ($screen-md) {
      display: flex;
      justify-content: flex-end;
    }
  }
  footer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    @media ($screen-sm) {
      justify-content: flex-end
    }
    >div {
      width: 100%;
      &:nth-child(2) {
        margin-left: 1rem;
      }
    }
    .btn {
      @media ($screen-sm) {
        margin-left: 2rem;
      }
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }

  @media screen and (min-width: 1200px) {
    .input-container {
      & > .btn {
        margin-bottom: 16px;
      }

      & > span {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
